import { render, staticRenderFns } from "./PredictionsList.vue?vue&type=template&id=d875186c&"
import script from "./PredictionsList.vue?vue&type=script&lang=js&"
export * from "./PredictionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports